import { useEffect } from "react";

const useDocumentTitle = (title) => {
    useEffect(() => {
       document.title = title + " " + document.title.substr(document.title.indexOf("|"), document.title.length - 1)
    }, [ title])
}

export default useDocumentTitle;